<template>
    <div class="container pt-2">
        <PageTitle main="Propostas Aceitas" sub="Propostas aceitas pelos clientes" />
        <div :style="{ overflow: overflowValue, width: larguraTela + 'px' }" v-if="larguraTela<721">
            <div class="row mb-3">
                <div class="col-md-7">
                </div>
                <div class="col-md-5">
                    <b-input-group>
                        <b-form-input
                        v-model="filtro"
                        type="search"
                        id="filterInput"
                        class="textInput"
                        placeholder="Pesquisar..."
                        ></b-form-input>
                        <b-input-group-append>
                        <b-button variant="outline-secondary" class="botaoInput" :disabled="!filtro" @click="filtro = ''">Limpar</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <b-table 
                hover 
                striped 
                id="table-orcamentos" 
                class="text-center table table-sm" 
                :items="orcamentos.length>0?orcamentos:[]" 
                :fields="fields" 
                per-page="5"
                :current-page="currentPage"
                :filter="filtro"
                :filterIncludedFields="filtrando"
                @filtered="onFiltered">
                <template v-slot:cell(actions)="data">
                    <b-button variant="info" class="mr-2 btn-sm mb-1 btn-size" @click="openModal(data.item)">
                        <i class="fas fa-info-circle"></i>
                    </b-button>
                    <b-button variant="warning" class="mr-2 btn-sm mb-1 btn-size" @click="openExtorno(data.item)">
                        <i class="fas fa-undo-alt"></i>
                    </b-button>
                    <b-button variant="danger" class="mr-2 btn-sm mb-1 btn-size" @click="setBaixado(data.item)">
                        <i class="far fa-eye-slash"></i>
                    </b-button>
                </template>
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
            <div>
                <b-pagination
                size="sm"
                v-model="currentPage"
                :total-rows="rows"
                per-page="5"
                aria-controls="table-orcamentos"
                first-number
                last-number
                align="center"
                ></b-pagination>
            </div>
        </div>
        <div v-else>
            <div class="row mb-3">
                <div class="col-md-7">
                </div>
                <div class="col-md-5">
                    <b-input-group>
                        <b-form-input
                        v-model="filtro"
                        type="search"
                        id="filterInput"
                        class="textInput"
                        placeholder="Pesquisar..."
                        ></b-form-input>
                        <b-input-group-append>
                        <b-button variant="outline-secondary" class="botaoInput" :disabled="!filtro" @click="filtro = ''">Limpar</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <b-table 
                hover 
                striped 
                id="table-orcamentos" 
                class="text-center table table-sm" 
                :items="orcamentos.length>0?orcamentos:[]" 
                :fields="fields" 
                per-page="5"
                :current-page="currentPage"
                :filter="filtro"
                :filterIncludedFields="filtrando"
                @filtered="onFiltered">
                <template v-slot:cell(actions)="data">
                    <b-button variant="info" class="mr-2 btn-sm mb-1 btn-size" @click="openModal(data.item)">
                        <i class="fas fa-info-circle"></i>
                    </b-button>
                    <b-button variant="warning" class="mr-2 btn-sm mb-1 btn-size" @click="openExtorno(data.item)">
                        <i class="fas fa-undo-alt"></i>
                    </b-button>
                    <b-button variant="danger" class="mr-2 btn-sm mb-1 btn-size" @click="setBaixado(data.item)">
                        <i class="far fa-eye-slash"></i>
                    </b-button>
                </template>
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
            <div>
                <b-pagination
                size="sm"
                v-model="currentPage"
                :total-rows="rows"
                per-page="5"
                aria-controls="table-orcamentos"
                first-number
                last-number
                align="center"
                >
                </b-pagination>
            </div>
        </div>
        <!-- MODAL PROPOSTA -->
        <b-modal id="modal-proposta" hide-footer>
            <template v-slot:modal-title>
                Dados do Transporte: {{ orcamento.codigo }}
            </template>
            <p>Cliente: {{ orcamento.cliente_nome }}</p>
            <hr>
            <p>Origem: {{ orcamento.origem_cep }} - {{ orcamento.origem }}</p>
            <p>Destino: {{ orcamento.destino_cep }} - {{ orcamento.destino }}</p>
            <hr>
            <p>Tipo de Carga: {{ orcamento.carga_titulo }}</p>
            <p v-if="orcamento.caminhao!=='0' && orcamento.caminhao!==undefined">Tipo de Caminhão: {{ orcamento.caminhao_titulo }}</p>
            <p v-else>Tipo de Caminhão: Não há especificação para este item!</p>
            <hr>
            <p v-if="orcamento.data_inicio!=='0000-00-00' && orcamento.data_inicio!==undefined">Previsão de Envio: {{ formatData(orcamento.data_inicio) }}</p>
            <p v-else>Previsão de Envio: Não há especificação para este item!</p>
            <p v-if="orcamento.data_final!=='0000-00-00' && orcamento.data_final!==undefined">Previsão de Entrega: {{ formatData(orcamento.data_final) }}</p>
            <p v-else>Previsão de Entrega: Não há especificação para este item!</p>
            <hr>
            <p>Transação: {{ orcamento.transacao_referencia }}</p>
            <hr>
            <p>Meio de Pagamento: {{ orcamento.transacao_meioPagamento }}</p>
            <hr>
            <p v-if="orcamento.transacao_meioPagamento==='BOLETO'">Link do Boleto: <a target="_BLANCK" :href="orcamento.transacao_boleto">Aqui</a></p>
            <hr v-if="orcamento.transacao_meioPagamento==='BOLETO'">
            <p>Status Atual: {{ orcamento.status }}</p>
            <hr>
            <div class="row">
                <div class="col-md-12">
                    <b-button variant="danger" block class="mt-3 botaoInput" @click="$bvModal.hide('modal-proposta')">Fechar</b-button>
                </div>
            </div>
        </b-modal>
        <!-- MODAL EXTORNO -->
        <b-modal id="modal-extorno" hide-footer>
            <template v-slot:modal-title>
                Dados do Transporte: {{ orcamento.codigo }}
            </template>
            <p>Cliente: {{ orcamento.cliente_nome }}</p>
            <hr>
            <p>Origem: {{ orcamento.origem_cep }} - {{ orcamento.origem }}</p>
            <p>Destino: {{ orcamento.destino_cep }} - {{ orcamento.destino }}</p>
            <hr>
            <p>Transação: {{ orcamento.transacao_referencia }}</p>
            <hr>
            <p>Meio de Pagamento: {{ orcamento.transacao_meioPagamento }}</p>
            <hr>
            <p v-if="orcamento.transacao_meioPagamento==='BOLETO'">Link do Boleto: <a target="_BLANCK" :href="orcamento.transacao_boleto">Aqui</a></p>
            <hr v-if="orcamento.transacao_meioPagamento==='BOLETO'">
            <p>Status Atual: {{ orcamento.status }}</p>
            <hr>
            <div class="row">
                <div class="col-md-12">
                    <b-button v-if="orcamento.transacao_meioPagamento!=='BOLETO'" variant="success" block class="mt-3 botaoInput" @click="setExtorno">Estornar</b-button>
                    <b-button v-else variant="success" block class="mt-3 botaoInput" @click="openBoleto">Estornar</b-button>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <b-button variant="danger" block class="mt-3 botaoInput" @click="$bvModal.hide('modal-extorno')">Fechar</b-button>
                </div>
            </div>
        </b-modal>
        <!-- MODAL EXTORNO BOLETO -->
        <b-modal id="modal-boleto" hide-footer>
            <template v-slot:modal-title>
                Dados do Transporte: {{ orcamento.codigo }}
            </template>
            <div class="row">
                <div class="col-md-12">
                    <b-form-group label="Código do Banco:" label-for="boleto-banco">
                        <b-form-input id="boleto-banco" type="tel"
                            v-model="boleto.bank_code"/>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-md-8">
                    <b-form-group label="Agência:" label-for="boleto-agencia">
                        <b-form-input id="boleto-agencia" type="tel"
                            v-model="boleto.agencia"/>
                    </b-form-group>
                </div>
                <div class="col-md-4">
                    <b-form-group label="Dígito:" label-for="boleto-agencia_dv">
                        <b-form-input id="boleto-agencia_dv"
                            v-model="boleto.agencia_dv"/>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-md-8">
                    <b-form-group label="Conta:" label-for="boleto-conta">
                        <b-form-input id="boleto-conta" type="tel"
                            v-model="boleto.conta"/>
                    </b-form-group>
                </div>
                <div class="col-md-4">
                    <b-form-group label="Dígito:" label-for="boleto-conta_dv">
                        <b-form-input id="boleto-conta_dv"
                            v-model="boleto.conta_dv"/>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <b-form-group label="Tipo de Conta:" label-for="boleto-tipo">
                        <b-form-select id="boleto-tipo" :options="tipos" v-model="boleto.type"/>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <b-form-group label="Titular da Conta:" label-for="boleto-nome">
                        <b-form-input id="boleto-nome"
                            v-model="boleto.legal_name"/>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <b-form-group label="CPF do Titular da Conta:" label-for="boleto-cpf">
                        <b-form-input id="boleto-cpf"
                            v-model="boleto.document_number"/>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <b-button variant="success" block class="mt-3 botaoInput" @click="setExtorno">Estornar</b-button>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <b-button variant="danger" block class="mt-3 botaoInput" @click="closeBoleto">Cancelar</b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>

import { baseApiUrl } from '@/global'
import axios from 'axios'
import PageTitle from '@/components/template/PageTitle'
import { VueEasyJwt } from 'vue-easy-jwt'

export default {
    name: 'orcamentos',
    components: { PageTitle },
    data: function() {
        return {
            exibeRodape: true,
            currentPage: 1,
            filtro: null,
            filtrando: [],
            totalRows: 1,
            jwt: new VueEasyJwt(),
            orcamento: {},
            orcamentos: [],
            extorno: {},
            boleto: {},
            proposta: {},
            fields: [
                { key: 'codigo', label: 'Código', sortable: true, thClass: 'tituloTabela', tdClass: 'fieldsTabela' },
                { key: 'status', label: 'Status', sortable: true, thClass: 'tituloTabela', tdClass: 'fieldsTabela' },
                { key: 'cliente_nome', label: 'Cliente', sortable: true, thClass: 'tituloTabela', tdClass: 'fieldsTabela' },
                { key: 'origem', label: 'Origem', sortable: true, thClass: 'tituloTabela', tdClass: 'fieldsTabela' },
                { key: 'destino', label: 'Destino', sortable: true, thClass: 'tituloTabela', tdClass: 'fieldsTabela' },
                { key: 'actions', label: 'Ações', thClass: 'tituloTabela', tdClass: 'actionsTabela' }
            ],
            tipos: [
                { value: 'conta_corrente', text: 'Conta Corrente' },
                { value: 'conta_poupanca', text: 'Conta Poupança' },
                { value: 'conta_corrente_conjunta', text: 'Conta Corrente Conjunta' },
                { value: 'conta_poupanca_conjunta', text: 'Conta Poupança Conjunta' }
            ],
            larguraTela: 0,
            overflowValue: 'auto',
            level: '',
            quemRecebeu: '',
            nome: '',
            email: ''
        }
    },
    computed: {
        rows() {
            return this.orcamentos.length
        }
    },
    methods: {
        setBaixado(item) {
            axios['post'](`${baseApiUrl}/backend/definirBaixa.php`, item)
            .then(() => {
                // const tipo = `?tipo=novoorcamento`
                // const destinoEmail = `&destinoEmail=${this.email}`
                // const destinoNome = `&destinoNome=${this.nome}`
                // axios.get(`${baseApiUrl}/backend/mailorcamento.php${tipo}${destinoEmail}${destinoNome}`).then({})

                this.$toasted.global.defaultSuccess({ message : 'Baixa realizada com sucesso!' })
                this.reset()
            })
            .catch(
                (e) => {
                this.$toasted.global.defaultError({ message : e.response.data['dados'] })
            })
        },
        openBoleto() {
            this.$bvModal.hide('modal-extorno')
            this.$bvModal.show('modal-boleto')
        },
        closeBoleto() {
            this.$bvModal.hide('modal-extorno')
            this.$bvModal.hide('modal-boleto')
        },
        setExtorno() {
            if(this.orcamento.transacao_meioPagamento==="BOLETO") {
                this.boleto.codigo = this.orcamento.transacao_referencia
                this.boleto.orcamento = this.orcamento.id
                axios['post'](`${baseApiUrl}/backend/refund.php`, this.boleto)
                .then(() => {
                    // const tipo = `?tipo=novoorcamento`
                    // const destinoEmail = `&destinoEmail=${this.email}`
                    // const destinoNome = `&destinoNome=${this.nome}`
                    // axios.get(`${baseApiUrl}/backend/mailorcamento.php${tipo}${destinoEmail}${destinoNome}`).then({})

                    this.$toasted.global.defaultSuccess({ message : 'Estorno realizado com sucesso!' })
                    this.reset()
                    this.$bvModal.hide('modal-boleto')
                    this.$bvModal.hide('modal-extorno')
                })
                .catch(
                    (e) => {
                    this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                })
            }else{
                this.extorno.codigo = this.orcamento.transacao_referencia
                this.extorno.orcamento = this.orcamento.id
                axios['post'](`${baseApiUrl}/backend/refund.php`, this.extorno)
                .then(() => {
                    // const tipo = `?tipo=novoorcamento`
                    // const destinoEmail = `&destinoEmail=${this.email}`
                    // const destinoNome = `&destinoNome=${this.nome}`
                    // axios.get(`${baseApiUrl}/backend/mailorcamento.php${tipo}${destinoEmail}${destinoNome}`).then({})

                    this.$toasted.global.defaultSuccess({ message : 'Estorno realizado com sucesso!' })
                    this.reset()
                    this.$bvModal.hide('modal-boleto')
                })
                .catch(
                    (e) => {
                    this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                })
            }
        },
        formatData(data) {
            const arr = data.split('-')
            const y = arr[0]
            const m = arr[1]
            const d = arr[2]
            return `${d}/${m}/${y}`
        },
        openModal(item){
            this.orcamento = item
            this.$bvModal.show('modal-proposta')
        },
        openExtorno(item){
            this.orcamento = item
            this.$bvModal.show('modal-extorno')
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
        loadOrcamentos() {
            const url = `${baseApiUrl}/backend/orcamentosAceitos.php`
            axios.get(url).then(res => {
                this.orcamentos = res.data
                if(this.orcamentos.length > 0) {
                    this.exibeRodape = false
                }else{
                    this.exibeRodape = true
                }
            })
        },
        reset() {
            this.proposta = {}
            this.orcamento = {}
            this.extorno = {}
            this.loadOrcamentos()
        },
        validaLogin() {
            const local = localStorage.getItem('__SYSTEM_USER')
            const decodedToken = this.jwt.decodeToken(local)
            if (local === null) {
                this.$router.push({ path: '/login' })
            } else {
                this.level = decodedToken['data'].level
                this.quemRecebeu = decodedToken['data'].id
                this.nome = decodedToken['data'].nome
                this.email = decodedToken['data'].email
            }
        }
    },
    mounted() {
        this.validaLogin()
        if (this.level === 'cliente') {
            this.$router.push('/')
        }
        this.loadOrcamentos()
        this.larguraTela = screen.width - (screen.width * 0.08)
        this.totalRows = this.orcamentos.length
    }
}
</script>

<style>
    
</style>